<template>
    <b-row class="vh-100" align-v="center">
        <b-col cols="12" md="10" offset-md="1" align-self="center">
            <b-row align-h="center">
                <b-col cols="12" class="text-center mb-4">
                    <div class="mb-3">
                        <img src="data:image/png;base64,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" alt="AIK Banka" class="bank-logo">
                    </div>
                    <p class="subtitle text-muted">{{ $t('aikbank.subtitle') }}</p>
                </b-col>

                <b-col cols="12" class="mb-4">
                    <h4 class="section-title text-center mb-4">{{ $t('aikbank.productsTitle') }}</h4>
                    
                    <b-row>
                        <b-col v-for="(product, index) in products" :key="index" cols="12" md="6" lg="4" class="mb-4">
                            <div class="product-card" :class="`product-card-${product.variant}`">
                                <div class="product-icon mb-3">
                                    <b-icon :icon="product.icon" font-scale="2.5"></b-icon>
                                </div>
                                <h5 class="product-title">{{ product.title }}</h5>
                                <p class="product-description">{{ product.description }}</p>
                                <ul class="product-features">
                                    <li v-for="(feature, fIndex) in product.features" :key="fIndex">
                                        <b-icon icon="check2" class="mr-1"></b-icon>
                                        <span>{{ feature }}</span>
                                    </li>
                                </ul>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="12" class="benefits-section mb-4">
                    <div class="benefits-box">
                        <h4 class="text-center mb-3">
                            <b-icon icon="star-fill" variant="warning" class="mr-2"></b-icon>
                            {{ $t('aikbank.benefitsTitle') }}
                        </h4>
                        <b-row>
                            <b-col v-for="(benefit, index) in benefits" :key="index" cols="12" md="6" class="mb-3">
                                <div class="benefit-item">
                                    <b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon>
                                    <span>{{ benefit }}</span>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>

                <b-col cols="12" class="mt-3">
                    <b-button variant="primary" size="lg" @click="success" block class="continue-button">
                        <b-icon icon="arrow-right-circle" class="mr-2"></b-icon>
                        {{ $t('aikbank.continue') }}
                    </b-button>
                    <p class="text-muted text-center mt-3 small">
                        {{ $t('aikbank.continueNote') }}
                    </p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import OnboardingLayout from '@/components/integrations/OnboardingLayout.vue'

export default {
    components: {
        OnboardingLayout
    },

    data: function() {
        return {}
    },

    i18n: {
        messages: {
            en_US: {
                aikbank: {
                    title: 'Welcome to AIK Bank',
                    subtitle: 'Your trusted partner for comprehensive banking solutions',
                    productsTitle: 'Our Products & Services',
                    benefitsTitle: 'Why Choose AIK Bank?',
                    continue: 'Continue with AIK Bank',
                    continueNote: 'By continuing, you agree to proceed with AIK Bank integration',
                    
                    // Products
                    product1Title: 'Current Accounts',
                    product1Desc: 'Flexible current accounts for individuals and businesses',
                    product1Feature1: 'Free online banking',
                    product1Feature2: 'Debit cards included',
                    product1Feature3: 'Mobile banking app',
                    product1Feature4: 'Competitive fees',
                    
                    product2Title: 'Savings Accounts',
                    product2Desc: 'Grow your savings with attractive interest rates',
                    product2Feature1: 'High interest rates',
                    product2Feature2: 'Flexible terms',
                    product2Feature3: 'No hidden fees',
                    product2Feature4: 'Instant access',
                    
                    product3Title: 'Business Loans',
                    product3Desc: 'Financing solutions to grow your business',
                    product3Feature1: 'Competitive rates',
                    product3Feature2: 'Flexible repayment',
                    product3Feature3: 'Fast approval',
                    product3Feature4: 'Dedicated support',
                    
                    product4Title: 'Credit Cards',
                    product4Desc: 'Premium credit cards with exclusive benefits',
                    product4Feature1: 'Cashback rewards',
                    product4Feature2: 'Travel insurance',
                    product4Feature3: 'No annual fee options',
                    product4Feature4: 'Global acceptance',
                    
                    product5Title: 'Payment Processing',
                    product5Desc: 'Accept payments online and in-store seamlessly',
                    product5Feature1: 'Multiple payment methods',
                    product5Feature2: 'Secure transactions',
                    product5Feature3: 'Real-time reporting',
                    product5Feature4: 'Low transaction fees',
                    
                    product6Title: 'Business Services',
                    product6Desc: 'Complete banking services for your business needs',
                    product6Feature1: 'Payroll services',
                    product6Feature2: 'Invoice management',
                    product6Feature3: 'Treasury solutions',
                    product6Feature4: 'Business consulting',
                    
                    // Benefits
                    benefit1: '24/7 customer support via phone, email, and chat',
                    benefit2: 'State-of-the-art security and fraud protection',
                    benefit3: 'Extensive ATM and branch network across Serbia',
                    benefit4: 'Special rates for Protokol platform users',
                    benefit5: 'Fast-track account opening and integration',
                    benefit6: 'Dedicated account manager for business clients'
                }
            },

            sr: {
                aikbank: {
                    title: 'Dobrodošli u AIK Banku',
                    subtitle: 'Vaš pouzdan partner za sveobuhvatna bankarska rešenja',
                    productsTitle: 'Naši Proizvodi i Usluge',
                    benefitsTitle: 'Zašto Izabrati AIK Banku?',
                    continue: 'Nastavi sa AIK Bankom',
                    continueNote: 'Nastavljajući, pristajete na integraciju sa AIK Bankom',
                    
                    // Products
                    product1Title: 'Tekući Računi',
                    product1Desc: 'Fleksibilni tekući računi za fizička i pravna lica',
                    product1Feature1: 'Besplatno online bankarstvo',
                    product1Feature2: 'Uključene debitne kartice',
                    product1Feature3: 'Mobilna bankarska aplikacija',
                    product1Feature4: 'Konkurentne naknade',
                    
                    product2Title: 'Štedni Računi',
                    product2Desc: 'Povećajte vašu štednju sa atraktivnim kamatnim stopama',
                    product2Feature1: 'Visoke kamatne stope',
                    product2Feature2: 'Fleksibilni uslovi',
                    product2Feature3: 'Bez skrivenih naknada',
                    product2Feature4: 'Trenutni pristup sredstvima',
                    
                    product3Title: 'Poslovni Krediti',
                    product3Desc: 'Finansijska rešenja za rast vašeg poslovanja',
                    product3Feature1: 'Konkurentne kamate',
                    product3Feature2: 'Fleksibilno otplaćivanje',
                    product3Feature3: 'Brzo odobrenje',
                    product3Feature4: 'Posvećena podrška',
                    
                    product4Title: 'Kreditne Kartice',
                    product4Desc: 'Premium kreditne kartice sa ekskluzivnim pogodnostima',
                    product4Feature1: 'Cashback nagrade',
                    product4Feature2: 'Putno osiguranje',
                    product4Feature3: 'Opcije bez godišnje naknade',
                    product4Feature4: 'Globalna prihvaćenost',
                    
                    product5Title: 'Procesiranje Plaćanja',
                    product5Desc: 'Prihvatajte plaćanja online i u prodavnici besprekorno',
                    product5Feature1: 'Višestruki metodi plaćanja',
                    product5Feature2: 'Sigurne transakcije',
                    product5Feature3: 'Izveštavanje u realnom vremenu',
                    product5Feature4: 'Niske transakcione naknade',
                    
                    product6Title: 'Poslovne Usluge',
                    product6Desc: 'Kompletne bankarske usluge za vaše poslovne potrebe',
                    product6Feature1: 'Usluge obračuna plata',
                    product6Feature2: 'Upravljanje fakturama',
                    product6Feature3: 'Treasury rešenja',
                    product6Feature4: 'Poslovno savetovanje',
                    
                    // Benefits
                    benefit1: 'Korisnička podrška 24/7 putem telefona, email-a i chat-a',
                    benefit2: 'Najsavremenija bezbednost i zaštita od prevara',
                    benefit3: 'Ekstenzivna mreža bankomata i filijala širom Srbije',
                    benefit4: 'Specijalne stope za korisnike Protokol platforme',
                    benefit5: 'Ubrzano otvaranje računa i integracija',
                    benefit6: 'Posvećen account manager za poslovne klijente'
                }
            }
        }
    },

    computed: {
        products() {
            return [
                {
                    icon: 'wallet2',
                    variant: 'primary',
                    title: this.$t('aikbank.product1Title'),
                    description: this.$t('aikbank.product1Desc'),
                    features: [
                        this.$t('aikbank.product1Feature1'),
                        this.$t('aikbank.product1Feature2'),
                        this.$t('aikbank.product1Feature3'),
                        this.$t('aikbank.product1Feature4')
                    ]
                },
                {
                    icon: 'piggy-bank',
                    variant: 'success',
                    title: this.$t('aikbank.product2Title'),
                    description: this.$t('aikbank.product2Desc'),
                    features: [
                        this.$t('aikbank.product2Feature1'),
                        this.$t('aikbank.product2Feature2'),
                        this.$t('aikbank.product2Feature3'),
                        this.$t('aikbank.product2Feature4')
                    ]
                },
                {
                    icon: 'cash-stack',
                    variant: 'info',
                    title: this.$t('aikbank.product3Title'),
                    description: this.$t('aikbank.product3Desc'),
                    features: [
                        this.$t('aikbank.product3Feature1'),
                        this.$t('aikbank.product3Feature2'),
                        this.$t('aikbank.product3Feature3'),
                        this.$t('aikbank.product3Feature4')
                    ]
                },
                {
                    icon: 'credit-card',
                    variant: 'warning',
                    title: this.$t('aikbank.product4Title'),
                    description: this.$t('aikbank.product4Desc'),
                    features: [
                        this.$t('aikbank.product4Feature1'),
                        this.$t('aikbank.product4Feature2'),
                        this.$t('aikbank.product4Feature3'),
                        this.$t('aikbank.product4Feature4')
                    ]
                },
                {
                    icon: 'cart-check',
                    variant: 'danger',
                    title: this.$t('aikbank.product5Title'),
                    description: this.$t('aikbank.product5Desc'),
                    features: [
                        this.$t('aikbank.product5Feature1'),
                        this.$t('aikbank.product5Feature2'),
                        this.$t('aikbank.product5Feature3'),
                        this.$t('aikbank.product5Feature4')
                    ]
                },
                {
                    icon: 'briefcase',
                    variant: 'secondary',
                    title: this.$t('aikbank.product6Title'),
                    description: this.$t('aikbank.product6Desc'),
                    features: [
                        this.$t('aikbank.product6Feature1'),
                        this.$t('aikbank.product6Feature2'),
                        this.$t('aikbank.product6Feature3'),
                        this.$t('aikbank.product6Feature4')
                    ]
                }
            ]
        },

        benefits() {
            return [
                this.$t('aikbank.benefit1'),
                this.$t('aikbank.benefit2'),
                this.$t('aikbank.benefit3'),
                this.$t('aikbank.benefit4'),
                this.$t('aikbank.benefit5'),
                this.$t('aikbank.benefit6')
            ]
        }
    },

    methods: {
        async success() {
            try {
                const data = await this.$store.dispatch('updateIntegrationOnboarding', {
                    integrationId: 'aikbank',
                    step: "view-products",
                    data: {
                        products_viewed: true,
                        viewed_at: new Date().toISOString()
                    }
                })

                console.log("AIK Bank onboarding updated:", data)

                if (data.onboarding.status == 'completed') {
                    this.$emit('onboardingSuccess', 'integration', 'aikbank')
                }
            } catch(err) {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            }
        }
    },

    mounted() {}
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/style.scss';
@import '@/assets/scss/_custom.scss';

.bank-logo-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: var(--card-bg, #fff);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
}

.bank-logo {
    max-width: 200px;
    height: auto;
}

.onboarding-title {
    font-size: 2rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
}

.subtitle {
    font-size: 1.1rem;
    margin-top: 0.5rem;
    color: var(--text-muted);
}

.section-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-primary);
    position: relative;
    padding-bottom: 0.75rem;
    
    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 3px;
        background: linear-gradient(90deg, #3d8bfd, #0d6efd);
        border-radius: 2px;
    }
}

.product-card {
    background: var(--card-bg, #fff);
    border-radius: 12px;
    padding: 1.5rem;
    height: 100%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.125));
    border-top: 4px solid transparent;
    
    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
        border-color: var(--border-color, rgba(0, 0, 0, 0.125));
    }
    
    &.product-card-primary {
        border-top-color: #3d8bfd;
        .product-icon { color: #3d8bfd; }
    }
    
    &.product-card-success {
        border-top-color: #28a745;
        .product-icon { color: #28a745; }
    }
    
    &.product-card-info {
        border-top-color: #17a2b8;
        .product-icon { color: #17a2b8; }
    }
    
    &.product-card-warning {
        border-top-color: #ffc107;
        .product-icon { color: #ffc107; }
    }
    
    &.product-card-danger {
        border-top-color: #dc3545;
        .product-icon { color: #dc3545; }
    }
    
    &.product-card-secondary {
        border-top-color: #6c757d;
        .product-icon { color: #adb5bd; }
    }
}

.product-icon {
    text-align: center;
    font-size: 2rem;
}

.product-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 0.5rem;
}

.product-description {
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 1rem;
}

.product-features {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
        display: flex;
        align-items: flex-start;
        padding: 0.4rem 0;
        font-size: 0.9rem;
        color: var(--text-secondary);
        
        .b-icon {
            color: #28a745;
            margin-right: 0.5rem;
            margin-top: 0.2rem;
            flex-shrink: 0;
        }
        
        span {
            flex: 1;
        }
    }
}

.benefits-section {
    .benefits-box {
        background: var(--card-bg, rgba(0, 102, 204, 0.05));
        border: 2px solid var(--border-color, rgba(0, 102, 204, 0.2));
        border-radius: 12px;
        padding: 2rem;
        
        h4 {
            font-size: 1.4rem;
            font-weight: 600;
            color: var(--text-primary);
        }
    }
}

.benefit-item {
    display: flex;
    align-items: flex-start;
    padding: 0.75rem;
    background: rgba(40, 167, 69, 0.1);
    border-radius: 6px;
    border: 1px solid rgba(40, 167, 69, 0.2);
    
    span {
        color: var(--text-primary);
        font-size: 0.95rem;
        line-height: 1.5;
    }
}

.continue-button {
    font-size: 1.2rem;
    font-weight: 600;
    padding: 1rem 2rem;
    transition: all 0.3s ease;
    background: linear-gradient(90deg, #3d8bfd, #0d6efd);
    border: none;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(13, 110, 253, 0.4);
        background: linear-gradient(90deg, #3d8bfd, #0d6efd);
        filter: brightness(1.1);
    }
}

.text-muted {
    color: var(--text-muted) !important;
}

// Dark theme specific adjustments
@media (prefers-color-scheme: dark) {
    .bank-logo-wrapper {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.15);
    }
    
    .section-title::after {
        background: linear-gradient(90deg, #6ea8fe, #3d8bfd);
    }
    
    .product-card {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(255, 255, 255, 0.1);
        
        &:hover {
            background: rgba(255, 255, 255, 0.08);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
        }
    }
    
    .benefits-box {
        background: rgba(61, 139, 253, 0.1) !important;
        border-color: rgba(61, 139, 253, 0.3) !important;
    }
    
    .benefit-item {
        background: rgba(40, 167, 69, 0.15);
        border-color: rgba(40, 167, 69, 0.3);
    }
}
</style>